import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";

// API
import { getMappedPosition } from "@Common/api/positions/queries";

// Layouts
import AppSideBar from "@/Layouts/components/SideBars/AppSideBar";
import BodyLayer from "@Layouts/components/Layers/BodyLayer";
import RoundedBox from "@Layouts/components/Basics/RoundedBox";
import EmptyBody from "@Layouts/components/Basics/EmptyBody";

// Model
import DepartmentalLayer from "@PayPlans/views/Layers/Departments/Managers/Departmental";

// MUI
import { Box, Grid } from "@mui/material";

// Images
import empty from "@/assets/images/commons/empty.png";
import NotDefined from "@/PayPlans/views/Layers/NotDefined";

// Constants
const position = "Parts Counter Associate";

const LayerLoader = () => {
	return (
		<BodyLayer
			fixedContent={
				<AppSideBar
					searchProps={{
						loading: true,
					}}
					appendProps={{
						tree: [],
						label: {
							title: "Default Pay Plans",
						},
						loadingRows: 2,
						loading: true,
						divider: true,
					}}
					sideBarProps={{
						tree: [],
						loading: true,
					}}
					actions={{
						spacing: 3,
						loading: true,
						operations: [
							{ icon: null, iconHover: null, loading: true },
							{ icon: null, iconHover: null, loading: true },
							{ icon: null, iconHover: null, loading: true },
						],
					}}
				/>
			}
		>
			<Box sx={{ width: 1 }}>
				<Grid container position="relative" spacing={1}>
					<Grid container item xs={12}>
						<RoundedBox sx={{ maxHeight: 630, boxShadow: "none !important" }}>
							<EmptyBody
								image={empty}
								title={`Select a ${position} Pay Plan`}
								bodyHeight={"510px"}
								sx={{
									boxShadow: "none !important",
								}}
							/>
						</RoundedBox>
					</Grid>
				</Grid>
			</Box>
		</BodyLayer>
	);
};

export default function Layer() {
	const location = useSelector((state) => state.location.location);
	const queryClient = useQueryClient();

	const { data, isLoading } = useQuery({
		queryKey: ["mappedPosition", "partsCounterAssociatePayPlan", location?.locationId],
		queryFn: async () => getMappedPosition(location?.locationId, position),
		enabled: !!location?.locationId,
		staleTime: Infinity,
	});

	useEffect(() => {
		return () => {
			queryClient.removeQueries(["mappedPosition", "partsCounterAssociatePayPlan", location?.locationId]);
		};
	}, [queryClient, location?.locationId]);

	if (isLoading) {
		return <LayerLoader />;
	}

	return (
		<>
			{data?.isDepartmental ? (
				<DepartmentalLayer position={position} defaultSections={["parts"]} />
			) : (
				<NotDefined position={position} />
			)}
		</>
	);
}
